var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemperature3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 44C38 47.3137 35.3137 50 32 50C28.6863 50 26 47.3137 26 44C26 41.7795 27.2072 39.8423 29 38.8047V23C29 21.3432 30.3432 20 32 20C33.6569 20 35 21.3432 35 23V38.8047C36.7929 39.8423 38 41.7795 38 44ZM41 36.0638C42.8668 38.1791 44 40.957 44 44C44 50.6278 38.6279 56 32 56C31.972 56 31.9429 55.9999 31.9148 55.9997C25.324 55.954 19.9666 50.5284 20.0002 43.9375C20.0156 40.9189 21.1461 38.1645 23 36.0638V17C23 12.0295 27.0295 8 32 8C36.9706 8 41 12.0295 41 17V36.0638ZM39.5 44C39.5 40.7807 37.6841 39.1072 36.5 37.7654V17C36.5 14.5187 34.4813 12.5 32 12.5C29.5188 12.5 27.5 14.5187 27.5 17V37.7654C26.3064 39.1181 24.5164 40.7748 24.5001 43.9604C24.4791 48.0738 27.8342 51.4713 31.946 51.4998L32 51.5C36.1355 51.5 39.5 48.1355 39.5 44Z",
    fill: "url(#hinava_random_uuid_291706085625986268707807106381527296153)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_291706085625986268707807106381527296153",
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature3);
export default __webpack_public_path__ + "static/media/temperature-3.56b70e15b5b6d3cf99665ad3449f4cff.svg";
export { ForwardRef as ReactComponent };